import Constants from '../../../../shared/constants';
import { CARD_STATES } from '../../../../shared/constants/workflow/WorkflowCardStatusConstant';

const clearCards = (state, action) => {
    const { columns } = state;
    const { emptyColumns } = action;
    const newColumns = { ...columns, ...emptyColumns };
    return { ...state, columns: newColumns };
};

const setFilters = (state, action) => {
    const { filters } = action;
    return {
        ...state,
        filters: { ...filters },
    };
};

const setSearch = (state, action) => {
    const { search } = action;
    return {
        ...state,
        search,
    };
};

const getColumnFromCard = (state, card) => {
    const type = card.status;
    return [...state.columns[type]];
};

const addCard = (state, action) => {
    let newCards = getColumnFromCard(state, action.card);
    newCards = newCards.map(elem => ({ ...elem, editing: false }));
    newCards.unshift({ ...action.card, editing: true });

    const newState = Object.assign({}, state);
    newState.columns[action.card.status] = newCards;
    return newState;
};

export const addCardInColumn = (state, action) => {
    const cards = getColumnFromCard(state, action.card);
    cards.unshift({ ...action.card });

    const columns = { ...state.columns, [action.card.status]: cards };
    return { ...state, columns };
};

const updateDeletedCard = (state, action) => {
    let newCards = [...state.excludedCards];
    newCards = newCards.map((item) => {
        if (item.id === action.card.id) {
            return { ...item, ...action.card, modified: true };
        }

        return { ...item };
    });

    return { ...state, excludedCards: newCards };
};

export const updateCard = (state, action) => {
    if (action.card.deleted) {
        return updateDeletedCard(state, action);
    }

    let newCards = getColumnFromCard(state, action.card);
    newCards = newCards.map((item) => {
        if (item.id === action.card.id && !action.card.is_read_only) {
            return { ...item, ...action.card, modified: true };
        }

        return { ...item };
    });
    const columns = { ...state.columns, [action.card.status]: newCards };
    return { ...state, columns };
};

const removeCardFromColumn = (state, action) => {
    const oldCards = getColumnFromCard(state, action.card);
    const newCards = oldCards.filter(item => item.id !== action.card.id);
    const columns = { ...state.columns, [action.card.status]: newCards };

    return { ...state, columns };
};

const removeCard = (state, action) => {
    const newState = removeCardFromColumn(state, action);

    const excludedCard = { ...action.card, deleted: true, modified: true };
    const excludedCards = [...(state.excludedCards || []), excludedCard];

    return { ...newState, excludedCards };
};

const duplicateCard = (state, action) => {
    let newCards = getColumnFromCard(state, action.card);
    newCards = newCards.map(elem => ({ ...elem, editing: false }));

    const indexOfCard = newCards.map(card => card.id).indexOf(action.card.id);

    const newCard = action.card;
    newCards.splice(indexOfCard + 1, 0, newCard);

    const newState = { ...state };
    newState.columns[action.card.status] = newCards;
    return newState;
};

export const moveCard = (state, action) => {
    const { card, column, index } = action;
    const finalColumn = column;
    let automationStatus = card.automation_status;

    if (card.control_type === Constants.CARD_CONTROL_TYPES.SEMI_AUTOMATIC) {
        automationStatus = column === CARD_STATES.DOING
            ? Constants.CARD_AUTOMATION_STATUS.STATUS_SCHEDULED : card.automation_status;
    }

    let newState = { ...state };
    newState = removeCardFromColumn(newState, action);
    const cards = [...newState.columns[finalColumn]];
    const newCard = {
        ...card,
        status: finalColumn,
        modified: true,
        automation_status: automationStatus,
    };

    cards.splice(index, 0, newCard);

    const columns = { ...newState.columns, [finalColumn]: cards };
    return { ...newState, columns };
};

const changeColumn = (state, action) => {
    let newCards = [...state.cards];
    const index = newCards.filter(x => x.status === action.status).length;

    newCards = newCards.map((item) => {
        if (item.id === action.card.id) {
            return { ...item, status: action.status, index };
        }

        return { ...item };
    });

    return Object.assign({}, state, { cards: newCards });
};

const createColumn = (state, action) => {
    const type = action.columnType;
    const columns = state.columns || {};
    columns[type] = [];

    return Object.assign({}, state, { columns });
};

const receiveCards = (state, action) => {
    const { cards } = action;
    const columns = { ...state.columns };

    const excludedCards = [];
    cards.forEach((card) => {
        if (card.deleted || card.is_dismissed) {
            excludedCards.push({ ...card });
            return;
        }

        const column = [...columns[card.status]];
        const cardAlreadyExists = column.find(columnCard => columnCard.id === card.id);
        if (column && !cardAlreadyExists) {
            column.push({ ...card, modified: false });
        }
        columns[card.status] = column;
    });

    return {
        ...state,
        columns,
        excludedCards,
        lastSync: Date.now(),
        cardsWithError: [],
    };
};

function replaceCard(state, action) {
    const newCards = getColumnFromCard(state, action.oldCard).map((item) => {
        if (item.id === action.oldCard.id) {
            return { ...action.newCard, modified: false };
        }

        return { ...item };
    });

    const columns = { ...state.columns, [action.oldCard.status]: newCards };
    return { ...state, columns };
}

function markAsSynced(state, action) {
    if (action.card.deleted || action.card.is_dismissed) {
        let newCards = [...state.excludedCards];
        newCards = newCards.map((item) => {
            if (item.id === action.card.id) {
                return { ...item, ...action.card, modified: false };
            }

            return { ...item };
        });

        return { ...state, excludedCards: newCards };
    }

    let newCards = getColumnFromCard(state, action.card);
    newCards = newCards.map((item) => {
        if (item.id === action.card.id) {
            return { ...item, ...action.card, modified: false };
        }

        return { ...item };
    });

    const columns = { ...state.columns, [action.card.status]: newCards };
    return { ...state, columns, lastSync: Date.now() };
}

const setLoggedUser = (state, action) => {
    const { user } = action;

    return { ...state, loggedUser: user };
};

const markCardWithError = (state, action) => {
    const { cardId, message, eventId } = action;
    const { cardsWithError } = state;

    const newCardsWithError = [...cardsWithError, { id: cardId, message, eventId }];

    return {
        ...state,
        cardsWithError: newCardsWithError,
    };
};

const updateIsDragging = (state, action) => ({
    ...state,
    isDragging: action.isDragging,
});

export {
    addCard,
    changeColumn,
    createColumn,
    removeCard,
    removeCardFromColumn,
    receiveCards,
    replaceCard,
    markAsSynced,
    clearCards,
    setFilters,
    setSearch,
    setLoggedUser,
    markCardWithError,
    duplicateCard,
    updateIsDragging,
};
